import { render } from "./productSearch.vue?vue&type=template&id=6b5b1fda&scoped=true"
import script from "./productSearch.vue?vue&type=script&lang=js"
export * from "./productSearch.vue?vue&type=script&lang=js"

import "./productSearch.vue?vue&type=style&index=0&id=6b5b1fda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5b1fda"]])

export default __exports__